import i18n from "i18n";
import { useQuery } from "@tanstack/react-query";
import { ArchiveArchiveIndexSet } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
const getArchiveIndexSetConfiguration = async () => ArchiveArchiveIndexSet.indexSetConfig();
export const ARCHIVE_INDEX_SET_CONFIGURATION_QUERY_KEY = "archive_index_set_configuration";
const useArchiveIndexSetConfiguration = ({ enabled } = { enabled: true }) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [ARCHIVE_INDEX_SET_CONFIGURATION_QUERY_KEY],
    queryFn: () => defaultOnError(
      getArchiveIndexSetConfiguration(),
      i18n.t("notifications.fetch_index_set_configuration_failed", { ns: "enterprise_archive" }),
      i18n.t("notifications.fetch_index_set_configuration_failed_title", { ns: "enterprise_archive" })
    ),
    enabled
  });
  return {
    data,
    isLoading,
    refetch
  };
};
export default useArchiveIndexSetConfiguration;
